const config = {
  environment: 'prod',
  redirect_url: 'https://hotglue.xyz/callback',
  api_url: 'https://api.hotglue.com',
  legacy_api_url: 'https://client-api.hotglue.xyz'
};

export default config;
